import { Button } from "@chakra-ui/react";
import { BsArrowLeft } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { useBreakpointValue } from "@chakra-ui/react";
const DashboardBanner = () => {
  const navigate = useNavigate();
  const isDesktop = useBreakpointValue({ base: false, md: true });
  return (
    <div
      style={{
        background: `url("./VTUBanner.jpeg")`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: isDesktop ? "top" : "left",
        backgroundSize: "cover",
        borderRadius: "10px",
        height: isDesktop ? "160px" : "150px",
        border: "2px solid #E0E0E0",
        display: "flex",
        justifyContent: "end",
        marginTop: "1em",
        alignItems: "center",
        cursor: "pointer",
      }}
      onClick={() => navigate("/vtu")}
    >
      <Button
        sx={{
          d: "flex",
          alignItems: "center",
          gap: "8px",
          position: "relative",
          overflow: "hidden",
          "::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: "-75%",
            width: "50%",
            height: "100%",
            background:
              "linear-gradient(120deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.6) 50%, rgba(255,255,255,0.1) 100%)",
            transform: "skewX(-20deg)",
            animation: "glisten 2.5s infinite",
            pointerEvents: "none",
          },
          "@keyframes glisten": {
            "0%": { left: "-75%" },
            "60%": { left: "120%" },
            "100%": { left: "120%" },
          },
        }}
        colorScheme="teal"
        size="lg"
        m={4}
      >
        Explore our VTU Services <BsArrowLeft />
      </Button>
    </div>
  );
};

export default DashboardBanner;
